import { Link, NavLink, Outlet } from 'react-router-dom';
import { company } from '../data/content';

function Header() {
  return (
    <header className="header">
      <div className="container">
        <Link to="/" className="header__logo">
          <img src="/pulmakivi_logo.svg" alt={company.name} />
        </Link>
        <nav className="header__nav">
          <NavLink to="/">Norppa</NavLink>
          <NavLink to="/ajankohtaista">Ajankohtaista</NavLink>
          <NavLink to="/tuki">Tuki</NavLink>
        </nav>
      </div>
    </header>
  );
}

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__links">
          <Link to="/tietosuoja">Tietosuojakäytäntö</Link>
          <Link to="/kayttoehdot">Käyttöehdot</Link>
          <Link to="/yritys">Tietoa yrityksestä</Link>
        </div>
        <p className="footer__copy">© {year} {company.name}</p>
      </div>
    </footer>
  );
}

export default function Layout() {
  return (
    <>
      <Header />
      <main className="page">
        <div className="container">
          <Outlet />
        </div>
      </main>
      <Footer />
    </>
  );
}
